var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('span',{staticClass:"progress-bar-text"},[_vm._v(_vm._s(_vm.percent)+"%")]),_c('div',{staticClass:"progress-bar",style:({ width: _vm.percent + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }